/*
 * @Author: jankergg
 * @Date:   2019-08-05 10:56:31
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-12-26 21:59:47
 */
import Vue from "vue";
import Vuex, { createNamespacedHelpers } from "vuex";
import paging from "./paging";

Vue.use(Vuex);

//引入数据持久化插件vuex-persistedstate
import createPersistedState from "vuex-persistedstate";

export default new Vuex.Store({
  state: {
    openid: "", //openid
    code: "", //code
    login: "", //用户id
    wxname: "", //用户微信昵称
    rightbtns: [],
    dian: false, //小红点
    bgpan: "0", //标题栏背景颜色判断
    rightbtnclick: { index: 0, tag: 0 },
    leftbtnclick: { index: 0, tag: 0 },
  },
  getters: {
    code: (state) => state.code,
    openid: (state) => state.openid,
    login: (state) => state.login,
    wxname: (state) => state.wxname,
    dian: (state) => state.dian,
    bgpan: (state) => state.bgpan,
    rightBtnClick: (state) => state.rightbtnclick,
    rightBtns: (state) => state.rightbtns,
    leftBtnClick: (state) => state.leftbtnclick,
  },
  modules: {
    paging,
  },
  mutations: {
    SET_CODE: (state, token) => {
      state.code = token;
    },
    SET_OPENID: (state, token) => {
      state.openid = token;
    },
    SET_WXNAME: (state, token) => {
      state.wxname = token;
    },
    SET_LOGIN: (state, token) => {
      state.login = token;
    },
    SET_DIAN: (state, token) => {
      state.dian = token;
    },
    SET_BGPAN: (state, token) => {
      state.bgpan = token;
    },
    SET_RIGHTBTNCLICK: (state, tag) => {
      state.rightbtnclick = { index: state.rightbtnclick.index + 1, tag: tag };
    },
    SET_LEFTBTNCLICK: (state, tag) => {
      console.log(state, tag);
      state.leftbtnclick = { index: state.leftbtnclick.index + 1, tag: tag };
    },
  },
  actions: {},
  //配置数据持久化 这里是所有vuex里数据都持久化
  plugins: [createPersistedState()],
});

// 在页面即将刷新前触发
window.addEventListener("beforeunload", () => {
  // 将 store 中的数据以 JSON 字符串的形式保存到 localStorage 中
  localStorage.setItem("vuex-state", JSON.stringify(store.state));
});

// 在页面加载时尝试从本地存储中还原数据
const savedState = localStorage.getItem("vuex-state");
if (savedState) {
  store.replaceState(JSON.parse(savedState));
}

const { mapActions, mapState } = createNamespacedHelpers("Dict");
export const dictAction = mapActions;
export const dictState = mapState;
